// extracted by mini-css-extract-plugin
export default {"card":"OverviewSection_card__6Vm3l","section-title":"OverviewSection_section-title__7jfh0","overview-item-wrap":"OverviewSection_overview-item-wrap__2L3u6"};